import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetAllTransports = async (SchoolID) => {
  try {
    const TransportsCollection = collection(db, "Transports");

    const q = query(
      TransportsCollection,
      where("SchoolID", "==", SchoolID),
      where("IsDeleted", "==", false)
    );
    const TransportsSnapshot = await getDocs(q);

    let TransportsData = [];

    TransportsSnapshot.forEach((doc) => {
      TransportsData.push({ ...doc.data(), id: doc.id });
    });
    return TransportsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllTransports;
